// extracted by mini-css-extract-plugin
module.exports = {"white100":"#fff","primary":"#400099","primaryD10":"#2b0066","snackbar":"member-operations__withSnackBar__snackbar","icon":"member-operations__withSnackBar__icon"};